var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-e6652d81": "",
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    "data-v-e6652d81": "",
    id: titleId
  }, "tab-radius-l") : title ? /*#__PURE__*/React.createElement("title", {
    "data-v-e6652d81": "",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-v-e6652d81": "",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "#616568",
    fillRule: "evenodd",
    "data-is-selected": "false",
    className: "s-fill-betSlip-icon-light dark:s-fill-betSlip-icon-dark"
  }, /*#__PURE__*/React.createElement("path", {
    "data-v-e6652d81": "",
    d: "M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z",
    id: "tab-radius-l",
    transform: "translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgLeft);
export default __webpack_public_path__ + "static/media/svg-left.ece6f68c1379e93b13d5731a5d828756.svg";
export { ForwardRef as ReactComponent };